import React from 'react'

const Forbidden = () => {
  return (
    <div className='flex flex-col items-center pt-64 p-5'>
      <h1 className='font-fig-extrabold text-5xl font-medium text-blue-600 mb-2 tracking-tight'>403</h1>
      <h1 className='font-fig-extrabold text-3xl font-medium text-gray-900 tracking-tight'>You don't have access to this feature</h1>
    </div>
  )
}

export default Forbidden